import React, { useEffect, useRef, useState } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css'; // Leaflet CSS for proper map rendering
import { useParams } from 'react-router-dom';
import { MedicalEmergencyHelper } from '../../../../../../../util/medical-emergency/MedicalEmergencyHelper';
import MedicalEmergencyService from '../../../../../../../services/medical-emergency/medical-emergency.service';
import smallclose_icon from '../../../../../../../assets/close_small.svg'; // Import the SVG

import './FlightLocationDemo.css'; // Import your CSS file

const FlightLocationDemo = () => {
  const mapRef = useRef(null); // Reference for the map container
  const mapInstanceRef = useRef(null); // Reference for the map instance
  const planeMarkerRef = useRef(null); // Reference for the plane marker
  const { medicalEmergencyId } = useParams();
  const [currentCrewLocation, setCurrentCrewLocation] = useState({});
  const [loading, setLoading] = useState(true); // Loading state
  const [isModalOpen, setIsModalOpen] = useState(true); // Modal is open by default on component load

  // Fetch the crew location data
  async function findCrew() {
    try {
      const medicalEmergencyHelper = new MedicalEmergencyHelper();
      let cognitoUserIdCrew = await medicalEmergencyHelper.findCrewName(medicalEmergencyId);
      const currentLocation = await MedicalEmergencyService.getCrewLocation(cognitoUserIdCrew);
      setCurrentCrewLocation(currentLocation);
    } catch (error) {
      console.error('Error fetching crew location', error);
    } finally {
      setLoading(false); // Once data is fetched, set loading to false
    }
  }

  useEffect(() => {
    // Call the API initially when the component mounts
    findCrew();

    // Set up an interval to call the API every 5 minutes (300000ms)
    const intervalId = setInterval(findCrew, 300000); // 300000 ms = 5 minutes

    // Cleanup the interval when the component is unmounted or modal is closed
    return () => {
      clearInterval(intervalId); // Clean up the interval when component is unmounted
    };
  }, [medicalEmergencyId]); // This useEffect will run every time medicalEmergencyId changes

  // Check if latitude and longitude are available before rendering map
  const { latitude, longitude } = currentCrewLocation;
  const isLocationAvailable = latitude && longitude;

  useEffect(() => {
    // Initialize the map only when the modal is open and location is available
    if (isModalOpen && isLocationAvailable && mapRef.current && !mapInstanceRef.current) {
      // Initialize the map only if it hasn't been initialized yet
      mapInstanceRef.current = L.map(mapRef.current, {
        center: [latitude, longitude], // Set center to current crew location
        zoom: 12, // Set zoom level to see the region clearly
      });

      // Add OpenStreetMap tile layer (free and open-source)
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      }).addTo(mapInstanceRef.current);

      // Create a custom icon using Unicode (plane symbol)
      const planeIcon = L.divIcon({
        className: 'leaflet-venue-icon', // Optional: You can add your custom class here
        html: '<div style="font-size: 30px; color: blue;">&#9992;</div>', // Plane Unicode as HTML
        iconSize: [30, 30], // Size of the icon
        iconAnchor: [15, 15], // Anchor to center the icon
      });

      // Add the custom icon at the crew's location
      planeMarkerRef.current = L.marker([latitude, longitude], { icon: planeIcon }).addTo(mapInstanceRef.current);

      // Set the view of the map to the crew's location
      mapInstanceRef.current.setView([latitude, longitude], 12);
    }

    // Cleanup function to destroy the map instance on modal close
    return () => {
      if (mapInstanceRef.current) {
        mapInstanceRef.current.remove(); // Cleanup the map instance
        mapInstanceRef.current = null; // Set to null
      }
    };
  }, [isModalOpen, isLocationAvailable, latitude, longitude]); // Run when modal opens or location changes

  // Function to close modal when close icon is clicked
  const closeModal = () => {
    setIsModalOpen(false);
  };

  // Function to update the plane marker when location data changes
  const updateLocationOnMap = () => {
    if (planeMarkerRef.current) {
      // Update the position of the plane marker
      planeMarkerRef.current.setLatLng([latitude, longitude]);
      mapInstanceRef.current.setView([latitude, longitude], 12); // Optional: Adjust the map view to the new location
    }
  };

  useEffect(() => {
    // Update the plane marker position when location changes
    if (isLocationAvailable) {
      updateLocationOnMap();
    }
  }, [latitude, longitude]); // This will run whenever latitude or longitude changes

//   if (loading) {
//     // return <div>Loading...</div>; // Show loading message if data is still being fetched
//   }

//   if (!isLocationAvailable) {
//     return <div>No location data available yet.</div>; // Show message if location data is missing
//   }

  return (
    <div>
      {isModalOpen && (
        <div className="modal">
          <div className="modal-content">
            <span className="close" onClick={closeModal}>
              <img src={smallclose_icon} alt="Close" className="close-icon" />
            </span>
            <div
              id="map"
              ref={mapRef}
              style={{ width: '100%', height: '100%', overflow: 'auto' }} // Map size inside the modal and enable scrolling
            ></div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FlightLocationDemo;
